import { Box, Button, Card, CircularProgress, Typography } from "@mui/material"
import { AtendimentoViewProps, mapDispatchToAtendimentoProps, mapStateToAtendimentoProps } from "../atendimento.controller"
import { connect } from "react-redux";
import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { PathRotaAtendimento } from "../atendimento.router";
import { AninharView, rotas } from "../../../services/router";
import { ApplicationState } from "../../../store";

function AtendimentoShell(props: AtendimentoViewProps){
    const { atendimentoState, atendimentoActions } = props;
    const { loading, msg, sessaoStarted } = atendimentoState

    console.log("props Atendimento",props)
    useEffect(() => {
        console.log("useEffect AtendimentoShell")
        atendimentoActions.startAtendimento();
    }, [])

    useEffect(() => {
        if (loading && !sessaoStarted)
            rotas.navigate(PathRotaAtendimento.entrada)
        if (!loading && !sessaoStarted)
            rotas.navigate(PathRotaAtendimento.abrirAtendimento)
        if (!loading && sessaoStarted)
            rotas.navigate(PathRotaAtendimento.atendendo)
    }, [loading, sessaoStarted])

    return (
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "center", alignContent: "center", width: "100%" }}>
            <AninharView />
        </Box>
    )
}

export default connect(mapStateToAtendimentoProps, mapDispatchToAtendimentoProps)(AtendimentoShell)

interface AtendimentoStartProps {
    loading:boolean,sessaoStarted:boolean,msg:string
}

const mapStateToAtendimentoStartProps = (state:ApplicationState) => ({
    loading:state.atendimentoState.loading,
    msg:state.atendimentoState.msg,
    sessaoStarted:state.atendimentoState.sessaoStarted
})

export const AtendimentoStart = connect(mapStateToAtendimentoStartProps)((props:AtendimentoStartProps) => {
    const { loading,msg,sessaoStarted } = props
    console.log("chamou AtendimentoStart")
    if (loading && !sessaoStarted)
        return <Typography variant="h4" textAlign={"center"}>{msg}</Typography>
    return (
        <Box sx={{display:"flex",flex:1, flexDirection:"column", justifyContent:"center", alignItems: "center"}}>
            <Typography>Preparando sala de atendimento...</Typography>
            <CircularProgress />
        </Box>
    )
})


